import React from 'react';
import { useNavigate } from 'react-router-dom';

interface AdminHeaderProps {
  onLogout?: () => void;
}

const AdminHeader: React.FC<AdminHeaderProps> = ({ onLogout }) => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    if (onLogout) {
      onLogout();
      return;
    }
    try {
      await fetch('/api/auth/logout', {
        method: 'POST',
        credentials: 'include'
      });
    } catch (error) {
      console.error('Logout error:', error);
    }
    navigate('/login', { replace: true });
  };

  return (
    <header
      className="border-b px-8 py-5 backdrop-blur-sm"
      style={{
        backgroundColor: 'rgba(10, 9, 8, 0.92)',
        borderColor: 'var(--dusk-line)',
      }}
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-3">
          <h1
            className="text-2xl font-bold tracking-wide m-0"
            style={{ color: 'var(--dusk-copper)', fontFamily: 'var(--font-body)' }}
          >
            DUSKPROOF Admin
          </h1>
        </div>

        <div className="flex items-center space-x-3">
          <a
            href="/"
            target="_blank"
            rel="noopener noreferrer"
            className="px-4 py-2 rounded-full text-sm font-medium no-underline transition-all duration-300 flex items-center space-x-2"
            style={{ color: 'var(--dusk-muted)' }}
            onMouseEnter={(e) => {
              e.currentTarget.style.color = 'var(--dusk-ink)';
              e.currentTarget.style.background = 'var(--dusk-admin-hover)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.color = 'var(--dusk-muted)';
              e.currentTarget.style.background = 'transparent';
            }}
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
            </svg>
            <span>View Site</span>
          </a>
          <button
            onClick={handleLogout}
            className="px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 flex items-center space-x-2 border"
            style={{
              background: 'rgba(208, 0, 104, 0.12)',
              color: 'var(--dusk-amber)',
              borderColor: 'rgba(208, 0, 104, 0.35)',
            }}
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
            </svg>
            <span>Logout</span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default AdminHeader;
